import PageError from "./PageError.jsx";
import { Component } from "react";
import { postRequest } from "./request.js";
import { LOG_EVENT_TYPES } from "./appConstants.js";
import appHistory from "./appHistory.js";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            from: this.props.from || 'web',
        };

        appHistory.listen((location) => {
            this.setState({
                error: false,
            })
        });
    }

    componentDidCatch(error, errorInfo) {
        postRequest('/log', {
            type: LOG_EVENT_TYPES.exception,
            payload: {
                error,
                stack: errorInfo.componentStack,
                string: error.toString(),
                stringify: JSON.stringify(error),
            }
        }).then();
        this.setState({ error: error });
    }

    render() {
        const { headerText = 'Something went wrong', linkText } = this.props;
        if (this.state.error) {
            return <PageError linkText={linkText} headerText={headerText} code={'500'} error={this.state.error}/>
        } else {
            return <>{this.props.children}</>;
        }
    }
}

export default ErrorBoundary;